import { useEffect, useState } from "react";
import { fileUrl } from "@/lib/api";
import { pickSrc, cachedUrl, loadImage } from "@/components/player/preload";
import { InteractiveLayer } from "@/components/player/InteractiveLayer";
import { TextLayer } from "@/components/player/TextLayer";
import { BookLoader } from "@/components/BrandLoader";

export const PageView = ({ page, layers, lines, highlight, size, lowBandwidth, active, onAction, playingAudio, onFirstPaint, flat }) => {
  const src = pickSrc(page, size.w, lowBandwidth);
  const [url, setUrl] = useState(() => cachedUrl(src));
  const [loaded, setLoaded] = useState(() => !!cachedUrl(src));
  const [slow, setSlow] = useState(false);
  useEffect(() => {
    let on = true;
    const hit = cachedUrl(src);
    setUrl(hit); setLoaded(!!hit); setSlow(false);
    if (hit) { onFirstPaint?.(); return; }
    const t = setTimeout(() => on && setSlow(true), 900);
    loadImage(src).then((u) => on && setUrl(u)).catch(() => on && setUrl(src));
    return () => { on = false; clearTimeout(t); };
  }, [src]); // eslint-disable-line react-hooks/exhaustive-deps
  return (
    <div className={`relative select-none bg-white ${flat ? "" : "shadow-[0_24px_50px_-18px_rgba(100,116,139,.55)]"}`} style={{ width: size.w, height: size.h }} data-testid={`player-page-${page.index}`}>
      {!loaded && <img src={cachedUrl(fileUrl(page.thumb)) || fileUrl(page.thumb)} alt="" aria-hidden className="absolute inset-0 h-full w-full" draggable={false} />}
      {url && <img
        src={url}
        alt={`Page ${page.index}`}
        className="absolute inset-0 h-full w-full transition-opacity duration-200"
        style={{ opacity: loaded ? 1 : 0 }}
        onLoad={() => { setLoaded(true); onFirstPaint?.(); }}
        fetchPriority={active ? "high" : "low"}
        draggable={false}
      />}
      {!loaded && slow && <div className="pointer-events-none absolute bottom-3 right-3 grid h-9 w-9 place-items-center rounded-xl bg-white/85 shadow-md" data-testid={`page-loading-${page.index}`}><BookLoader size={14} /></div>}
      {lines?.length > 0 && <TextLayer lines={lines} height={size.h} highlight={highlight} />}
      {(layers || []).filter((l) => !l.hidden).map((l) => (
        <InteractiveLayer key={l.id} layer={l} active={active} onAction={onAction} playingAudio={playingAudio} />
      ))}
    </div>
  );
};
